const contacts = (state = [], action) => {
    switch (action.type) {
      case 'CONTACTS':
          return action.contacts.map(contacts => {
            return contacts
          })
      case 'DELCONTACT':
        return state.filter(contacts =>
          parseInt(contacts.id) !== parseInt(action.contactid)
        )
      case 'CLEARCONTACTS':
          return [];
      default:
        return state
    }
  }
  
  export default contacts